"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var material_ui_image_1 = require("material-ui-image");
var Typography_1 = require("@material-ui/core/Typography");
var itemDetailsStyles_1 = require("./itemDetailsStyles");
var ItemDetails = function (_a) {
    var itemData = _a.itemData;
    var styles = itemDetailsStyles_1.default();
    return (<core_1.Box>
      <material_ui_image_1.default src={itemData.picture} alt={itemData.label} animationDuration={0} className={styles.image} imageStyle={itemDetailsStyles_1.imageStyle} style={{ paddingTop: 0, position: 'unset' }} color="transparent" data-test={'checkout:expressions_of_interest:item:image'}/>
      <core_1.Box className={styles.details}>
        <Typography_1.default variant={'subtitle1'} data-test={'checkout:expressions_of_interest:item:title'} className={styles.title}>
          {itemData.label}
        </Typography_1.default>
        <Typography_1.default variant={'body1'} data-test={'checkout:expressions_of_interest:item:description'} className={styles.description}>
          {itemData.description}
        </Typography_1.default>
      </core_1.Box>
    </core_1.Box>);
};
exports.default = ItemDetails;
